export default __webpack_public_path__ + "static/media/download.5976a380.svg";